import './chatbotTibot.scss';

const ChatbotTibot = () => {
    // Componente deshabilitado - No renderiza nada
    return null;
    
    /* Código original comentado:
    return (
        <a id="chatIcon" href="javascript:" className="tibot-chat">
            <div class="tibot-chat__text openchat">Chatea con <strong>TiBot</strong></div>
            <div id="notification" class="chatbot-pratech-floating-badge"><label id="countNotification"></label></div>
        </a>
    )
    */
};

export default ChatbotTibot;
